import { createReducer, updateItemInArray, updateObject } from 'helpers/ReducerUtil'
import {
  UPDATE_VALUE,
  REMOVE_VALUE,
  ADD_VALUE,
} from './constants'

const addValue = (values, action) => [...values, {}]

const removeValue = (values, { index }) => values.filter(
  (value, currentIndex) => index !== currentIndex
)

const updateValue = (values, { value, index, inputType }) => {
  let obj = values[index]
  if (!obj) {
    obj = {}
  }
  obj[inputType] = value
  return [obj]
}
const multiFieldSimpleReducer = createReducer([{}], {
  [ADD_VALUE]: addValue,
  [REMOVE_VALUE]: removeValue,
  [UPDATE_VALUE]: updateValue
})

export default multiFieldSimpleReducer
